import { useQuery } from "@apollo/client"
import { DateRangeInput } from "@blueprintjs/datetime"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import StaticSelector from "components/Atoms/StaticSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import dayjs from "dayjs"
import { PERIODIC_TASK_TYPES } from "graphql/selector.queries.gql"
import React, { useMemo } from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"

const InterfaceFilter = () => {
  const [filter, setFilter] = useFilter("interfaces")
  const { data, loading } = useQuery(PERIODIC_TASK_TYPES)
  const taskTypes = useMemo(
    () => data?.allTasks?.map(s => ({ id: s, name: s })),
    [data]
  )
  return (
    <SearchFilter
      value={filter}
      getValues={(values: any) => setFilter(values)}
      onClear={() => setFilter({})}
      className="ml-3"
    >
      <SearchFilterCallout title="Activity Type">
        <CustomCheckbox className="mb-0" path="oneOff" label="One Off" />
      </SearchFilterCallout>
      <SearchFilterCallout title="Status">
        <CustomCheckbox className="mb-0" path="enabled" label="Enabled" />
      </SearchFilterCallout>
      <SearchFilterCallout title="Execution Time Range">
        <DateRangeInput
          popoverProps={{
            minimal: true,
          }}
          timePickerProps={{
            useAmPm: true,
            showArrowButtons: true,
          }}
          closeOnSelection={false}
          formatDate={date => dayjs(date).format("DD/MM/YYYY hh:mm:ss a")}
          onChange={range =>
            setFilter({
              ...filter,
              startTime: range,
            })
          }
          parseDate={str => new Date(str)}
          value={filter.startTime}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Task Type">
        <StaticSelector
          className="mb-0"
          loading={loading}
          path="task"
          items={taskTypes}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Response Status">
        <CustomCheckbox className="mb-0" path="isOk" label="Is Successfull" />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default InterfaceFilter
